exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#company-info[data-v-130608f2] {\n    background-color: #ebf2f7;\n    padding: 1.8em;\n}\n#company-info i[data-v-130608f2] {\n    vertical-align: middle;\n    color: #005a93;\n    padding-right: 0.2em;\n}\n", ""]);

// exports
